import * as v from 'valibot';
import { ProductProductTypeFilterSchema, ProductPosFilterSchema, RequiredStringSchema } from '~/schemas';
import { t } from 'i18next';
import { CampaignSplitFilterLight } from '~/api';
import { getTodayIsoDate } from '~/helpers';

const CampaignSplitProductProductTypeFilterSchema = v.object({
	...v.omit(ProductProductTypeFilterSchema, [ 'productClassId' ]).entries,
	productClassId: v.number(t('Vyberte možnost.')),
});

export const CampaignSplitFilterRequestSchema = v.object({
	posFilter: ProductPosFilterSchema,
	productTypeFilter: CampaignSplitProductProductTypeFilterSchema,
});

export const CampaignSplitStatisticsFilterRequestSchema = v.object({
	posFilter: ProductPosFilterSchema,
	productTypeFilter: ProductProductTypeFilterSchema,
});

export const CampaignSplitFilterGroupRequestSchema = v.object({
	name: RequiredStringSchema,
});

export const CampaignSplitFilterSaveRequestSchema = v.pipe(
	v.object({
		name: RequiredStringSchema,
		groupId: v.number(t('Vyberte možnost.')),
		from: v.nullable(v.pipe(v.string(), v.isoDate())),
		to: v.nullable(v.pipe(v.string(), v.isoDate())),
	}),
	v.forward(
		v.partialCheck(
			[ [ 'from' ], [ 'to' ] ],
			(input) => input.from == null || input.to == null || input.from <= input.to,
			t('Konec musí být později než začátek.'),
		),
		[ 'to' ],
	),
);

export const makeCampaignSplitFilterReplaceRequestSchema = (originalFilter: CampaignSplitFilterLight | null) => v.object({
	name: RequiredStringSchema,
	from: v.pipe(
		v.string(t('Zadejte datum.')),
		v.isoDate(t('Zadejte datum.')),
		v.check((input) => input >= getTodayIsoDate(), t('Datum nahrazení nesmí být v minulosti.')),
		v.check((input) => originalFilter?.from == null || input > originalFilter.from, t('Datum nahrazení musí být později než začátek původního filtru.')),
		v.check((input) => originalFilter?.to == null || input < originalFilter.to, t('Datum nahrazení musí být dříve než konec původního filtru.')),
	),
});
